import { forwardRef } from 'react';

import MuiFormControlLabel from '@mui/material/FormControlLabel';
const FormControlLabel = forwardRef((props, ref) => {
  return <MuiFormControlLabel ref={ref} {...props} />;
});
FormControlLabel.displayName = 'FormControlLabel';
export default FormControlLabel;
